<template>
  <v-form ref="form" lazy-validation>
    <div class="qam-calc-box">
      <v-row>
        <v-col cols="12" sm="4">
          <v-text-field v-model="flN" :counter="10" :rules="flnRules" :label="flnLabel" required></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-dialog attach v-model="datepickerfln" :close-on-content-click="false" transition="scale-transition"
            offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="computedDateFormatted" :label="fldLabel" persistent-hint prepend-icon="event"
                readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="flD" :first-day-of-week="1" locale="de-DE" no-title
              @input="datepickerfln = false"></v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="4">
          <v-btn id="search-fl" block color="success" class="mr-4" @click="validate">
            {{ searchString }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"><v-btn block x-small @click="goToMan">{{ withoutFlnString
            }}</v-btn></v-col>
      </v-row>
    </div>
    <div class="row qam-calc-c2a-div">
      <div class="col-12">
        <a href="#qam-compsections" class="btn btn-block qam-calc-c2a-button qam-shadow">{{ moreString }}</a>
      </div>
    </div>
  </v-form>
</template>

<script>
export default {
  name: "CoreTile",
  data: function () {
    return {
      flD: "",
      flN: "",
      datepickerfln: false,
      slang: "de",
      flnRules: [(v) => !!v || "Bitte geben Sie eine gültige Flugnummer ein"],
      flnLabel: "Flugnummer Problemflug (z.B. FR110)",
      fldLabel: "Flugdatum",
      searchString: "Flug kostenlos prüfen",
      withoutFlnString: "Flug ohne Flugnummer suchen?",
      moreString: "Mehr erfahren",
    };
  },
  mounted: function () {
    const queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    if (urlParams.has("slang")) {
      this.slang = urlParams.get("slang");
    } else {
      this.slang = navigator.language;
    }
    if (this.slang == "en") {
      this.flnLabel = "Flight number (e.g. FR110)";
      this.fldLabel = "Flight date";
      this.searchString = "Check your flight for free";
      this.withoutFlnString = "Search without flight number";
      this.moreString = "more";
      this.flnRules = [(v) => !!v || "Please fill in a valid flight number."];
    }
  },
  watch: {
    flD() {
      this.dateFormatted = this.formatDate(this.flD);
    },
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.flD);
    },
  },
  methods: {
    async validate() {
      if (!this.manRunSs) {
        if (this.$refs.form.validate()) {
          sessionStorage.setItem("flN", this.flN);
          sessionStorage.setItem("flD", this.flD);
          sessionStorage.setItem("manRunSs", "0");
          this.$ga.event("Rechner", "1. Flugdaten abgeschickt.");
          window.open(
            "https://www.qam-qam.com/fluggastportale/entschaedigungsrechner/",
            "_blank"
          );
        }
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    goToMan() {
      sessionStorage.setItem("manRunSs", "1");
      window.open(
        "https://www.qam-qam.com/fluggastportale/entschaedigungsrechner/",
        "_blank"
      );
    },
  },
};
</script>
